import React, { useEffect, useRef, useState } from 'react';
import { Star, Quote } from 'lucide-react';

const REVIEWS = [
  {
    name: 'Alexei Andros',
    quote:
      "Angela Trias at Akira Signature Care has been a life-changer for me. She's helped me with my weight loss, metabolic syndrome, and for the first time ever, my hormones are finally balanced! My hirsutism and cystic acne are also under control. She truly listens and connects all the dots. If you're dealing with hormonal or metabolic issues, Angela Trias at Akira Signature Care is the doctor you need!",
    initials: 'AA',
  },
  {
    name: 'Kay Tse',
    quote:
      "I have been seeing Angela Trias for about two years; I am so glad she finally opened up her own treatment clinic! I have had several services done by her (microneedling, melasma treatment, etc.) but I most recently had Xerf done by her and it was an amazing experience. Her office is very warm and inviting and she is an actual doctor with excellent communication, educational and informational skills. She answers all your questions, calms all your fears and best of all, she cares!! She really knows her stuff and only carries medical-grade products in her clinic. In an area where customer service is mostly lacking, I am glad to have Angela Trias treating me. She is truly a pleasant person/doctor and I would recommend her to anyone.",
    initials: 'KT',
  },
  {
    name: 'Julie Sullivan',
    quote:
      'The office manager Adriana is so kind and welcoming. Angela Trias is very thorough with her consultation and provided instant results! Love the office, my treatment and I will be back!',
    initials: 'JS',
  },
  {
    name: 'Kelly Tse',
    quote:
      'Angie Trias is incredibly kind and genuinely cares about her patients. She takes her time during every visit and always makes sure you feel comfortable—both physically and fully informed about the procedures. I always have a great experience when I see her and highly recommend her.',
    initials: 'KT',
  },
];

const Reviews = () => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      id="reviews"
      data-testid="reviews-section"
      className="py-28 bg-stone-50"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div
          className={`text-center mb-16 transition-all duration-1000 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="flex items-center justify-center gap-3 mb-5">
            <div className="w-8 h-px bg-rose-400" />
            <span className="text-rose-400 text-xs tracking-[0.4em] uppercase font-light">
              What Our Patients Say
            </span>
            <div className="w-8 h-px bg-rose-400" />
          </div>
          <h2
            className="text-stone-800 mb-4"
            style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: 'clamp(2rem, 4vw, 3rem)',
            }}
          >
            Stories from real patients
          </h2>
          <div className="flex items-center justify-center gap-1 mt-4">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-4 h-4 fill-rose-400 text-rose-400" />
            ))}
            <span className="ml-2 text-stone-500 text-sm font-light">
              From verified Google reviews
            </span>
          </div>
        </div>

        {/* Reviews grid */}
        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {REVIEWS.map((r, i) => (
            <article
              key={r.name}
              data-testid={`review-card-${i}`}
              className={`relative bg-white border border-stone-100 rounded-2xl p-8 lg:p-10 shadow-sm hover:shadow-xl transition-all duration-500 ${
                visible
                  ? 'opacity-100 translate-y-0'
                  : 'opacity-0 translate-y-6'
              }`}
              style={{ transitionDelay: visible ? `${i * 120}ms` : '0ms' }}
            >
              <Quote className="absolute top-6 right-6 w-7 h-7 text-rose-100" />

              <div className="flex items-center gap-1 mb-5">
                {[...Array(5)].map((_, k) => (
                  <Star
                    key={k}
                    className="w-3.5 h-3.5 fill-rose-400 text-rose-400"
                  />
                ))}
              </div>

              <blockquote className="text-stone-700 font-light leading-relaxed mb-6">
                “{r.quote}”
              </blockquote>

              <div className="flex items-center gap-3 pt-5 border-t border-stone-100">
                <div className="w-10 h-10 rounded-full bg-rose-50 flex items-center justify-center text-rose-500 font-semibold text-sm">
                  {r.initials}
                </div>
                <div>
                  <div className="text-stone-900 font-medium text-sm">
                    {r.name}
                  </div>
                  <div className="text-stone-400 text-xs">Verified patient</div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
